import styled from 'styled-components';

const Label = styled.div`
  color: #949494;
  font-weight: 600;
`;

const StyledGridOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

interface IGridRowsImageProps {
  label?: string;
}

export const GridRowsImage = ({ label }: IGridRowsImageProps) => (
  <StyledGridOverlay>
    <Label>{label}</Label>
  </StyledGridOverlay>
);
